<label class="titleControl">{{ labelTitle }}</label>
<input style="overflow: visible; position:relative"
	type="text"
	ngxDaterangepickerMd
	[(ngModel)]="selected"
	class="form-control"
	[closeOnAutoApply]="true"
	[autoApply]="autoApply"
	[showCancel]="false"
	[ranges]="ranges"
	[showCustomRangeLabel]="true"
	[alwaysShowCalendars]="true"
	[locale]="options"
	[keepCalendarOpeningWithRange]="true"
	[showRangeLabelOnInput]="false"
	[linkedCalendars]="false"
	placeholder="placeholder"
	[customRangeDirection]="false"
	[opens]="position"
	[drops]="'down'"
	(datesUpdated)="choosedDate($event)"
	(rangeClicked)="rangeChanged($event)"
	[showDropdowns]="true"
/>

